module.exports = __webpack_public_path__ + "images/footer_bg.png";